import React, { useState } from 'react';
import './Checkout.css';
import InitialData from './dadosIniciais/DadosIniciais';
import ReviewOrder from './revisarPedido/RevisarPedido';
import Payment from './pagamento/Pagamento';

const Checkout = () => {
  const [currentStep, setCurrentStep] = useState(0);
  const [orderId, setOrderId] = useState(null);
  const [qrCode, setQrCode] = useState(null);

  const handleNextStep = () => {
    setCurrentStep(currentStep + 1);
  };

  const handlePrevStep = () => {
    setCurrentStep(currentStep - 1);
  };


  const handleOrderConfirmation = (novoQrCode, id) => {
    setOrderId(id);
    setQrCode(novoQrCode);
    handleNextStep();
  };

  const steps = [
    { component: <InitialData onNext={handleNextStep} />, label: 'Dados Pessoais' },
    { component: <ReviewOrder onNext={handleNextStep} onPrev={handlePrevStep} onOrderConfirmation={handleOrderConfirmation} />, label: 'Revisar Pedido' },
    { component: <Payment onNext={handleNextStep} onPrev={handlePrevStep} orderId={orderId} qrCode={qrCode} />, label: 'Pagamento' }
  ];

  return (
    <div className="checkout">
      <div className="custom-progress-bar">
        {steps.map((step, index) => (
          <button key={index} className={index <= currentStep ? 'active' : 'inactive'}>
            {step.label}
          </button>
        ))}
      </div>
      <div className="step-container">
        {steps[currentStep].component}
      </div>
    </div>
  );
};

export default Checkout;